<template>
  <section>
    <a class="anchor" id="members"></a>
    <h2 class="title">{{$t('ourMembers')}} <span class="links"><a class="link" href="#1y">{{$t('1y')}}</a><a class="link" href="#2y">{{$t('2y')}}</a><a class="link" href="#3y">{{$t('3y')}}</a><a class="link" href="#4y">{{$t('4y')}}</a></span></h2>
    <div class="sub">
      <a class="anchor" id="1y"></a>
      <div class="parent">
        <h3>{{$t('1y')}}</h3>
        <div class="card" v-for="member in members[0]" :key="member.name" v-on:click="openDetail">
          <img class="member" :src="require('../assets/members/'+member.name+'.jpg')">
          <p class="text">{{member.name}}</p>
          <!-- <a href="#contact-us" style="display:block;position:absolute;left:0;top:0;width:100%;height:100%"></a> -->
        </div>
      </div>
    </div>
    <div class="sub">
      <a class="anchor" id="2y"></a>
      <div class="parent">
        <h3>{{$t('2y')}}</h3>
        <div class="card" v-for="member in members[1]" :key="member.name" v-on:click="openDetail">
          <img class="member" :src="require('../assets/members/'+member.name+'.jpg')">
          <p class="text">{{member.name}}</p>
        </div>
      </div>
    </div>
    <div class="sub">
      <a class="anchor" id="3y"></a>
      <div class="parent">
        <h3>{{$t('3y')}}</h3>
        <div class="card" v-for="member in members[2]" :key="member.name" v-on:click="openDetail">
          <img class="member" :src="require('../assets/members/'+member.name+'.jpg')">
          <p class="text">{{member.name}}</p>
        </div>
      </div>
    </div>
    <div class="sub">
      <a class="anchor" id="4y"></a>
      <div class="parent">
        <h3>{{$t('4y')}}</h3>
        <div class="card" v-for="member in members[3]" :key="member.name" v-on:click="openDetail">
          <img class="member" :src="require('../assets/members/'+member.name+'.jpg')">
          <p class="text">{{member.name}}</p>
        </div>
      </div>
    </div>
    <div id="card-detail-outside" class="zoverlay"></div>
    <div id="card-detail" class="card-detail scroll-custom ztop">
      <div class="left">
        <div>
          <img class="member-2" :src="require('../assets/members/'+selected.name+'.jpg')">
          <p>{{selected.name}}</p>
        </div>
      </div>
      <div class="right">
        <ul>
          <li v-if="selected.role"><strong>{{$t('role')}}</strong> : {{selected.role}}</li>
          <li v-if="selected.belonging"><strong>{{$t('belonging')}}</strong> : {{selected.belonging}}</li>
          <li v-if="selected.school_origin"><strong>{{$t('schoolOrigin')}}</strong> : {{selected.school_origin}}</li>
          <li v-if="selected.s1"><strong>S1</strong> : {{selected.s1}}</li>
          <li v-if="selected.goal"><strong>{{$t('goal')}}</strong> : {{selected.goal}}</li>
        </ul>
        <button id="card-detail-btn">X</button>
      </div>
    </div>
    <img class="deco-down" src="../assets/SVG/deco-side.svg">
  </section>
</template>

<script>

export default {
  name: 'Members',
  data() {
    return {
        test: 0,
        nb: 1,
        selected: {
          name: "ブシャダ　イリャス"
        },
        members: [
          [
            {
                name: '浅野陽平',
                role: "競技役員",
                belonging: 'III類',
                school_origin: '都立小川高校',
                s1: 'Fr',
                goal: '1Frで1分を切る'
            },
            {
                name: '出口智佳',
                role: "総務",
                belonging: '',
                school_origin: '東洋大学附属姫路高校',
                s1: 'Fr',
                goal: ''
            },
            {
                name: '徳光優斗',
                role: "エントリー",
                belonging: 'I類',
                school_origin: '大分上野丘高校',
                s1: 'Br',
                goal: '全国公の標準を切る'
            },
            {
                name: '野村佳佑',
                role: "会計",
                belonging: '',
                school_origin: '逗子開成高校',
                s1: 'Br',
                goal: '全国公出場'
            },
            {
                name: '松本健太郎',
                role: "HP",
                belonging: 'I類',
                school_origin: '国分寺高校',
                s1: 'Fr',
                goal: '自己ベスト出します'
            },
            {
                name: '佐々木愛里',
                role: "カメラ",
                belonging: 'III類',
                school_origin: '岩手県立水沢高等学校',
                s1: 'マネージャー',
                goal: ''
            },
          ],
          [
            {
                name: '和泉玲央',
                role: "副主将、イベント",
                belonging: 'III類',
                school_origin: '明星高校',
                s1: 'Fr',
                goal: '全国公出場'
            },
            {
                name: '伊藤裕人',
                role: "",
                belonging: 'III類',
                school_origin: '三国丘高校',
                s1: 'Ba',
                goal: '全国公に出る'
            },
            {
                name: '酒井宏伸',
                role: "主将",
                belonging: 'I類',
                school_origin: '逗子開成高校',
                s1: 'Fr',
                goal: 'ベスト更新'
            },
            {
                name: '桑山太斗',
                role: "幹事、調布祭",
                belonging: 'II類',
                school_origin: '駒場高校',
                s1: 'Fr',
                goal: 'ベストタイムを出す'
            },
          ],
          [
            {
                name: 'ブシャダ　イリャス',
                role: "ホームページ",
                belonging: 'I類',
                school_origin: 'Ecole Nationale Supérieure d\'Informatique （アルジェリア）',
                s1: 'Fr',
                goal: '全部の泳ぎができるようになることと、筋肉がつくこと'
            },
            {
                name: '角龍之介',
                role: '',
                belonging: 'III類',
                school_origin: '穎明館高校(東京都)',
                s1: 'Fly',
                goal: '全国公に出る！フル単！'
            },
            {
                name: '田中暁',
                role: '',
                belonging: 'II類',
                school_origin: '浜松西高校(静岡県)',
                s1: 'Fr',
                goal: '2Fr、4Frで全国公に行く'
            },
            {
                name: '福原魁人',
                role: '',
                belonging: 'II類',
                school_origin: '春日部高校(埼玉県)',
                s1: 'Ba',
                goal: '1Baで関カレ制限タイムをきる'
            },
            {
                name: '吉田航大',
                role: '',
                belonging: 'II類',
                school_origin: '東京学芸大学附属高校',
                s1: 'Br',
                goal: '半フリでベスト2秒更新'
            },
            {
                name: '中山真未',
                role: '',
                belonging: '駒沢女子大学',
                school_origin: '駒場学園高校(東京都)',
                s1: 'マネージャー',
                goal: '積極的に朝練と夕練に参加する。タイムの記録を繰り返し選手個人の平均タイムを把握していけるようする'
            },
            {
                name: '松井澄香',
                role: '',
                belonging: '駒沢女子大学',
                school_origin: ' 袋井高校(静岡県)',
                s1: 'マネージャー',
                goal: '正確なタイム測定とラップタイムの暗算'
            }
          ],
          [
            {
                name: '小野兼',
                role: '',
                belonging: 'II類計測•制御システムプログラム',
                school_origin: '時習館高校(愛知県)',
                s1: 'Br',
                goal: 'ベスト更新,インカレ出場'
            },
            {
                name: '高江優介',
                role: '',
                belonging: 'I類経営•社会情報学プログラム',
                school_origin: '長崎北高校(長崎県)',
                s1: 'Ba',
                goal: '200Ba2.35.00, 100Ba1.08.00を割る'
            },
            {
                name: '薬野龍之介',
                role: '',
                belonging: 'III類機械システムプログラム',
                school_origin: '豊多摩高校(東京都)',
                s1: 'Fr',
                goal: '100Fr,200Frベスト'
            },
            {
                name: '姫路康太郎',
                role: '',
                belonging: 'II類計測•制御システムプログラム',
                school_origin: '長崎西高校(長崎県)',
                s1: 'IM, Fly',
                goal: 'インカレ出場'
            },
            {
              name: '小島萌',
              role: '',
              belonging: '駒沢女子大学',
              school_origin: '安田学園高校(東京都)',
              s1: 'マネージャー',
              goal: '水とお友達になります'
            },
            {
                name: '市村彩佳',
                role: '',
                belonging: '駒沢女子大学',
                school_origin: '駒場学園高校(東京都)',
                s1: 'マネージャー',
                goal: '引退まで頑張る💪'
            }
          ],
          // [
          //   {
          //       name: '馬原愛斗',
          //       belonging: 'Ⅰ類,メディア情報学プログラム',
          //       school_origin: '広島皆実高校(広島県)',
          //       s1: 'Fr'
          //   },
          //   {
          //       name: '大場直洋',
          //       belonging: 'Ⅲ類,機械システムプログラム',
          //       school_origin: '酒田東高校(山形県)',
          //       s1: 'Fr'
          //   },
          //   {
          //       name: '日野凱斗',
          //       belonging: 'Ⅰ類,経営・社会情報学プログラム',
          //       school_origin: '出雲高校(島根県)',
          //       s1: 'Br'
          //   },
          //   {
          //       name: '久保健輔',
          //       belonging: 'Ⅰ類,メディア情報学プログラム',
          //       school_origin: '横須賀高校(神奈川県)',
          //       s1: 'Fr'
          //   },
          //   {
          //       name: '樺島宏樹',
          //       belonging: 'Ⅰ類,経営・社会情報学プログラム',
          //       school_origin: '筑陽学園高校(福岡県)',
          //       s1: 'Fr'
          //   },
          //   {
          //       name: '鈴木雄登',
          //       belonging: 'Ⅰ類,メディア情報学プログラム',
          //       school_origin: '神奈川総合高校(神奈川県)',
          //       s1: 'Fly'
          //   },
          //   {
          //       name: '磯田烈至',
          //       belonging: 'Ⅰ類,情報数理工学プログラム',
          //       school_origin: '川越高校(埼玉県)',
          //       s1: 'Ba'
          //   }
          // ]
        ]
    }
  },
  methods: {
    openDetail(e) {
      var cardDetail = document.getElementById("card-detail");
      var name = e.target.offsetParent.children[1].textContent;
      var selected = this.members.flat().find(el => el.name === name)
      this.selected = {};
      Object.assign(this.selected, selected);
      var target = e.target.offsetParent;
      var cardPosition = target.getBoundingClientRect(),
          cardTop = cardPosition.top,
          cardLeft = cardPosition.left,
          cardHeight = target.offsetHeight,
          cardWidth = target.offsetWidth;
      var windowScrollX = window.scrollX;
      var windowScrollY = window.scrollY;
      cardDetail.classList.add('card-detail-open');
      var windowWidth = window.innerWidth,
            windowHeight = window.innerHeight;
      var maxHeight = ( windowWidth > 500 ) ? 300 : 500;
      var cardDetailWidth = ( windowWidth*.8 > 700 ) ? 700 : windowWidth*.8,
            cardDetailHeight = ( windowHeight*.8 > maxHeight ) ? maxHeight : windowHeight*.8;
      var cardDetailTranslateX = parseInt((windowWidth - cardDetailWidth)/2 - cardLeft),
            cardDetailTranslateY = parseInt((windowHeight - cardDetailHeight)/2 - cardTop);
        //change card-detail height/width and translate it
      cardDetail.setAttribute('style', 'top:'+cardTop+'px;left:'+cardLeft+'px;height:'+cardDetailHeight+'px;width:'+cardDetailWidth+'px;transform: translateY('+cardDetailTranslateY+'px) translateX('+cardDetailTranslateX+'px)');
      document.getElementById("card-detail-outside").style.display = "block";
      Array.from(document.getElementsByClassName("card")).forEach((card) => card.style.pointerEvents = 'none');
      setTimeout(function(){target.setAttribute('style','visibility: hidden');}, 400);
      
      function cardDetailCloser(){
        cardPosition = target.getBoundingClientRect();
        cardTop = cardPosition.top - (windowScrollY-window.scrollY);
        cardLeft = cardPosition.left ;
        cardDetail.setAttribute('style', 'top:'+cardTop+'px;left:'+cardLeft+'px;height:'+cardHeight+'px;width:'+cardWidth+'px;transform: translateY('+-(window.scrollY-windowScrollY)+'px) translateX('+-(window.scrollX-windowScrollX)+'px)');
        cardDetail.classList.remove("card-detail-open");
        setTimeout(function(){
          target.setAttribute('style','visibility: visible');
        }, 750);
        setTimeout(function(){ 
          cardDetail.setAttribute('style', 'transform: translateY(0px) translateX(0px)')
          Array.from(document.getElementsByClassName("card")).forEach((card) => card.style.pointerEvents = 'auto');
        }, 850);
        document.getElementById("card-detail-outside").style.display = "none";
      }
      document.getElementById("card-detail-btn").onclick = cardDetailCloser;
      document.getElementById("card-detail-outside").onclick = cardDetailCloser;
    }
  }
}
</script>

<style scoped>
.card {
  display: table;
  background-color: white;
  text-align: center;
  position: relative;
  cursor: pointer;
  width: 150px;
  height: 150px;
  visibility: visible;
  transition: visibility .01s;

  border-radius: 10px;
}
.card > p {
  display: table-cell;
  vertical-align: middle;
}

.card-detail {
  position: fixed;
  top: 0;
  right: 0;
  background-color: white;
  width: 200px;
  height: 200px;
  visibility: hidden;
  transition: transform .4s, visibility .4s, width .4s, height .4s;
  transition-delay: .4s;
  border-radius: 10px;
  display: flex;
  overflow: auto;
  z-index: 100;
  box-shadow: 0 4px 12px 0px rgba(0,0,0,.25);
}
@media screen and (max-width: 500px) {
  .text {
    font-size: 11px !important;
  }
  .left {
    min-width: none !important;
    max-width: none !important;
  }
  .left, .right {
    display: block !important;
  }
  .card-detail {
    flex-direction: column;
  }
  .parent {
    grid-template-columns: repeat(auto-fill, 100px) !important;
  }
  .card, .member {
    width: 100px !important;
    height: 100px !important;
  }
  .member-2 {
    min-width: 50px !important;
    max-width: 150px;
    margin: 0 auto 15px auto !important;
  }
}
.card-detail-open {
  transform: translateX(0);
  visibility: visible;
}
#card-detail-outside {
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 99;
}


.left, .right {
  padding:30px;
  min-width: 150px;
  display: flex;
  align-items:center;
  
}
.left {
  max-width: 300px;
  padding: 5%;
  background-color: #008CBA;
  color:white;
  flex: 1;
}
.right {
    text-align: left;
    flex: 2;
}

#card-detail-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  font-size: 1.25em;
  cursor: pointer;
  background-color: #008CBA;
  color: white;
}

/* ------------------------------*/
.cell.is-empty {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}
  .text {
  color: white;
  font-size: 15px;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 50%;
  background-color: rgba(0,0,0,.5);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
.overlay {
  position: relative;
  top: 0;
  left: 0;
  height: 150px;
  width: 150px;
  z-index: 150;
  border-radius: 5%;
  margin: 0 auto;
  opacity: 0;
  transition: .5s ease;
  background-color: #008CBA;
}
.parent {
  display: grid;
  grid-template-columns: repeat(auto-fill, 150px);
  grid-gap: 1rem;
  justify-content: center;
}

.member {
  display: block;
  width: 150px;
  margin: 0 auto;
  border-radius: 5%;
}
.member-2 {
  display: block;
  width: auto;
  margin: 0 2% 15px 2%;
  border-radius: 50%;
}
@media only screen and (max-width: 1500px){
    .deco-down {
        bottom: -85px!important;
        width: 300px !important;
    }
}
   

  section {
    padding: 30px 10%;
    position: relative;
    z-index: 100;
  }
  .deco-down {
    width: 700px;
    position: absolute;
    left: 0;
    bottom: -150px;
    z-index: -100;
  }
  h2 {
        font-size: 48px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        padding-bottom: 20px;
        color: #005080;
    }
  h3 {
    font-size: 28px;
    text-align: left;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding-bottom: 10px;
    color: #005080;
    grid-column: 1/-1;
  }
  .sub {
    margin: 20px 0;
  }
  .link {
    font-size: 1rem;
    padding: 1px 4px;
    border-right: 2px solid;
  }
  .link:last-child {
    border-right: none;
    margin-right: 0;
  }
  .links {
    font-size: 1rem;
    padding-top: 10px;
    display: block;
  }
</style>